

<h2 class="mm" mat-dialog-title>{{title}}</h2>

<mat-dialog-content >
  {{description}}
</mat-dialog-content>
<tr></tr>
<mat-dialog-actions>
  <button   class="mat-raised-button"(click)="close()">Close</button>
</mat-dialog-actions>



